import React from 'react';

export default function PromotionSkeleton({ count = 4 }) {
    return (
        <>
            {Array.from({ length: count }).map((_, index) => (
                <div
                    className="promotion-item promotion-skeleton"
                    key={index}
                    aria-hidden="true"
                >
                    <div className="promotion-skeleton-image">
                        <span className="promotion-skeleton-status" />
                    </div>

                    <div className="promotion-item-content">
                        <div className="promotion-info promotion-skeleton-info">
                            <div className="promotion-skeleton-title" />
                            <div className="promotion-skeleton-subtitle" />
                        </div>

                        <div className="promotion-cta promotion-skeleton-actions">
                            <div className="promotion-skeleton-button" />
                            <div className="promotion-skeleton-button secondary" />
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
}
